import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { HomeComponent } from "./components/website/home/home.component";
import { AboutComponent } from "./components/website/about/about.component";
import { OffGridSolarComponent } from "./components/website/off-grid-solar/off-grid-solar.component";
import { OnGridSolarComponent } from "./components/website/on-grid-solar/on-grid-solar.component";
import { HybridSolarComponent } from "./components/website/hybrid-solar/hybrid-solar.component";
import { ContactComponent } from "./components/website/contact/contact.component";
import { SolarSubsidyComponent } from "./components/website/solar-subsidy/solar-subsidy.component";
import { BlogDetailComponent } from "./components/website/blog-detail/blog-detail.component";
import { BlogComponent } from "./components/website/blog/blog.component";
import { PrivacyPolicyComponent } from "./components/website/privacy-policy/privacy-policy.component";
import { TermsConditionsComponent } from "./components/website/terms-conditions/terms-conditions.component";
import { ReferAndEarnComponent } from "./components/website/refer-and-earn/refer-and-earn.component";

const routes: Routes = [
    { path: "", component: HomeComponent },
    { path: "about", component: AboutComponent },
    { path: "off-grid", component: OffGridSolarComponent },
    { path: "on-grid", component: OnGridSolarComponent },
    { path: "hybrid", component: HybridSolarComponent },
    { path: "solar-subsidy", component: SolarSubsidyComponent },
    { path: "contact", component: ContactComponent },
    { path: 'blog', component: BlogComponent },
    {
        path: 'blog/:id',
        component: BlogDetailComponent
    },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'terms-conditions', component: TermsConditionsComponent },
    { path: 'refer-and-earn', component: ReferAndEarnComponent },

    // {path: 'services', component: ServicesComponent},
    // {path: 'service-details', component: ServiceDetailsComponent},
    // { path: 'blog-details', component: BlogDetailsComponent },
    // {path: 'faq', component: FaqComponent},
    // {path: 'coming-soon', component: ComingSoonComponent},
    // {path: 'pricing', component: PricingComponent},
    // Here add new pages component

    { path: "**", component: NotFoundComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule { }
